"use client";

import { c as _c } from "react/compiler-runtime";
import { combineEmploymentTypes, getCanonicalUrl } from "@repo/design-system/utils/helpers";
import { QRCodeSVG } from "qrcode.react";
import { useLanguage } from "~/translations/loader/use-language";
import type { Job } from "~/types/job";
import { getPrintviewContact } from "../printview-contact";
export function PrintviewDetailsBox(t0) {
  const $ = _c(73);
  const {
    job
  } = t0;
  const t = useLanguage();
  let t1;
  if ($[0] !== job) {
    t1 = getPrintviewContact(job);
    $[0] = job;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const contact = t1;
  let t2;
  if ($[2] !== job) {
    t2 = getCanonicalUrl(job);
    $[2] = job;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const canonicalUrl = t2;
  const qrCodeUrl = `${canonicalUrl}?utm_source=PrintedJobad&utm_medium=Print&utm_campaign=QRCodePrint&utm_id=QRCodePrint&utm_term=QRCodePrint&utm_content=QRCodePrint`;
  let t3;
  if ($[4] !== t.jobad_detailsPrint_HL) {
    t3 = <h2 className="mb-3 font-bold text-primary">{t.jobad_detailsPrint_HL}</h2>;
    $[4] = t.jobad_detailsPrint_HL;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t.jobad_details_employmentType) {
    t4 = <p className="mb-1 font-bold">{t.jobad_details_employmentType}</p>;
    $[6] = t.jobad_details_employmentType;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== job.data.employmentType || $[9] !== t) {
    t5 = combineEmploymentTypes(job.data.employmentType, t);
    $[8] = job.data.employmentType;
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <p>{t5}</p>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t6) {
    t7 = <div>{t4}{t6}</div>;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t.jobad_details_contractType) {
    t8 = <p className="mb-1 font-bold">{t.jobad_details_contractType}</p>;
    $[16] = t.jobad_details_contractType;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== job.data.contract) {
    t9 = <p>{job.data.contract}</p>;
    $[18] = job.data.contract;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t8 || $[21] !== t9) {
    t10 = <div>{t8}{t9}</div>;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t.jobad_details_remote) {
    t11 = <p className="mb-1 font-bold">{t.jobad_details_remote}</p>;
    $[23] = t.jobad_details_remote;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== job.data.remote) {
    t12 = <p>{job.data.remote}</p>;
    $[25] = job.data.remote;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t11 || $[28] !== t12) {
    t13 = <div>{t11}{t12}</div>;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t.jobad_details_company) {
    t14 = <p className="mb-1 font-bold">{t.jobad_details_company}</p>;
    $[30] = t.jobad_details_company;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== job.data.company) {
    t15 = <p>{job.data.company}</p>;
    $[32] = job.data.company;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t14 || $[35] !== t15) {
    t16 = <div>{t14}{t15}</div>;
    $[34] = t14;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t.jobad_details_jobNumber) {
    t17 = <p className="mb-1 font-bold">{t.jobad_details_jobNumber}</p>;
    $[37] = t.jobad_details_jobNumber;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== job.data.jobNumber) {
    t18 = <p>{job.data.jobNumber}</p>;
    $[39] = job.data.jobNumber;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t17 || $[42] !== t18) {
    t19 = <div>{t17}{t18}</div>;
    $[41] = t17;
    $[42] = t18;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== contact || $[45] !== t.footer_contact) {
    t20 = contact && <div><p className="mb-1 font-bold">{t.footer_contact}</p><div><p>{contact.name}</p><p>{contact.mail}</p></div></div>;
    $[44] = contact;
    $[45] = t.footer_contact;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== t10 || $[48] !== t13 || $[49] !== t16 || $[50] !== t19 || $[51] !== t20 || $[52] !== t7) {
    t21 = <div className="mb-4 space-y-2 text-xs">{t7}{t10}{t13}{t16}{t19}{t20}</div>;
    $[47] = t10;
    $[48] = t13;
    $[49] = t16;
    $[50] = t19;
    $[51] = t20;
    $[52] = t7;
    $[53] = t21;
  } else {
    t21 = $[53];
  }
  let t22;
  if ($[54] !== t.jobad_inclusionHL) {
    t22 = <p className="mb-2 font-bold text-sm">{t.jobad_inclusionHL}</p>;
    $[54] = t.jobad_inclusionHL;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  let t23;
  if ($[56] !== t.jobad_inclusion_text) {
    t23 = <p data-source="lc">{t.jobad_inclusion_text}</p>;
    $[56] = t.jobad_inclusion_text;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  let t24;
  if ($[58] !== t22 || $[59] !== t23) {
    t24 = <div className="mb-4 py-2 text-xs">{t22}{t23}</div>;
    $[58] = t22;
    $[59] = t23;
    $[60] = t24;
  } else {
    t24 = $[60];
  }
  let t25;
  if ($[61] !== t.jobad_qrcode_HL) {
    t25 = <p className="mb-2 font-bold text-sm">{t.jobad_qrcode_HL}</p>;
    $[61] = t.jobad_qrcode_HL;
    $[62] = t25;
  } else {
    t25 = $[62];
  }
  let t26;
  if ($[63] !== qrCodeUrl) {
    t26 = <div className="py-1" suppressHydrationWarning={true}><QRCodeSVG size={80} value={qrCodeUrl} /></div>;
    $[63] = qrCodeUrl;
    $[64] = t26;
  } else {
    t26 = $[64];
  }
  let t27;
  if ($[65] !== t25 || $[66] !== t26) {
    t27 = <div className="break-inside-avoid">{t25}{t26}</div>;
    $[65] = t25;
    $[66] = t26;
    $[67] = t27;
  } else {
    t27 = $[67];
  }
  let t28;
  if ($[68] !== t21 || $[69] !== t24 || $[70] !== t27 || $[71] !== t3) {
    t28 = <div className="col-span-2 h-min p-4 pr-2">{t3}{t21}{t24}{t27}</div>;
    $[68] = t21;
    $[69] = t24;
    $[70] = t27;
    $[71] = t3;
    $[72] = t28;
  } else {
    t28 = $[72];
  }
  return t28;
}